import React, { useRef, useEffect, useState } from 'react'
import Icon from '../../component/icon'
import Notification from './notification'
import './index.less'

const useNotification = (config, onDestroy) => {
  const notificationRef = useRef()
  const [noticeAddFlag, setNoticeAddFlag] = useState(false)
  const noticeCount = useRef(0)

  useEffect(() => {
    Notification.newInstance({
      prefixCls: 'mn',
      closeIcon: <Icon type="m-guanbi" />,
      placement: 'rightBottom',
      ...config,
    }, notification => {
      notificationRef.current = notification
    })
  }, [])

  const open = (props = {}) => {
    notificationRef.current.notice({
      ...props,
      onClose: () => {
        noticeCount.current -= 1
        props?.onClose?.()
      }
    })
    noticeCount.current += 1
    setNoticeAddFlag(true)
  }

  const destroy = () => {
    notificationRef.current.destroy()
    onDestroy()
  }

  useEffect(() => {
    if (noticeAddFlag) {
      if (noticeCount.current === 0) {
        destroy()
      }
    }
  }, [noticeAddFlag])

  useEffect(() => {
    return () => {
      destroy()
    }
  }, [])

  const wrapApi = {
    open,
    destroy,
  }
  return [wrapApi]
}

export default useNotification
